import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "@/components/Reveal";

const FAQS = [
  {
    id: "legal",
    q: "Are these documents legally valid in my state?",
    a: "The templates use widely accepted commercial language — authorization clauses, lien notices, warranty disclaimers — that reflect common U.S. practice. Contract law does vary by state (especially lien procedures and late-fee caps), so we always recommend a one-hour review by a local attorney. That review costs a few hundred dollars once, versus thousands to draft from scratch — and the blanks for state, county, and fees are clearly marked.",
  },
  {
    id: "software",
    q: "What software do I need to open and edit the files?",
    a: "Nothing special. PDFs open and print from any phone, tablet, or computer. The profit calculator is a standard Excel file that also opens free in Google Sheets. Every document is plain, unlocked, and yours to edit — add your logo, change the wording, print a stack for the counter.",
  },
  {
    id: "formats",
    q: "Is this a subscription? Do I lose access if I stop paying?",
    a: "No subscription, ever. You pay once and download the files to your own device. They keep working whether we're around or not — that's the entire point of buying tools instead of renting software.",
  },
  {
    id: "refunds",
    q: "What's the refund policy on a digital download?",
    a: "A 14-day money-back guarantee while your files stay unopened. If a kit doesn't fit, email us within 14 days of purchase from your checkout email — full refund to your original payment method. Because the files are instantly downloadable, the guarantee ends once any file or the ZIP is downloaded (we track this per order). Broken or wrong files are always fixed or replaced free, whenever it happens.",
  },
  {
    id: "updates",
    q: "Do I get updates when templates improve?",
    a: "Shop Builder buyers get all version-2 updates free. Complete Shop System buyers get lifetime updates — when a clause improves or a document is added, you get the new file by email at no charge.",
  },
  {
    id: "mobile",
    q: "I work out of a service van. Does this fit mobile mechanics?",
    a: "The Starter Kit was built for you. Intake and authorization forms print two-up or pull up on your phone for a signature photo; the payment checklist assumes Square tap-to-pay on location. Thousands of mobile wrenchers run exactly this setup.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24 lg:py-32">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="Straight Answers // Shop Owner Inquiries"
          title="No-BS questions, answered"
          align="center"
        />
        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-12 space-y-3">
            {FAQS.map((f) => (
              <AccordionItem
                key={f.id}
                value={f.id}
                data-testid={`faq-item-${f.id}`}
                className="border border-slate-400/10 bg-panel px-6 data-[state=open]:border-blaze/40 transition-colors"
              >
                <AccordionTrigger className="text-left font-display font-bold uppercase tracking-tight text-base sm:text-lg text-slate-100 hover:text-blaze hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-400 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
